import { render, staticRenderFns } from "./BottomBorderNavLinks.vue?vue&type=template&id=7c563f0c&lang=html&"
import script from "./BottomBorderNavLinks.vue?vue&type=script&lang=js&"
export * from "./BottomBorderNavLinks.vue?vue&type=script&lang=js&"
import style0 from "./BottomBorderNavLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports